import { Link } from 'react-router'
import type { ReactNode } from 'react'

import './system.css'

export function Chip({
  to,
  tone = false,
  selected = false,
  onClick,
  children,
}: {
  to?: string | undefined
  tone?: boolean
  selected?: boolean
  onClick?: (() => void) | undefined
  children: ReactNode
}) {
  const classes = ['chip']

  if (tone) {
    classes.push('chip--tone')
  }

  if (selected) {
    classes.push('chip--selected')
  }

  const className = classes.join(' ')

  if (to) {
    return (
      <Link className={className} to={to}>
        {children}
      </Link>
    )
  }

  return (
    <button
      className={className}
      type="button"
      aria-pressed={selected}
      {...(onClick ? { onClick } : {})}
    >
      {children}
    </button>
  )
}
